import React from 'react'
import { AnchorsOfFormsWrappers } from '@constants/forms'
import { EstateAgentsForm } from '@shared/components/forms/estate-agents'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

interface ViewProps {
	title: string
	data: { summary: { icon: string; text: string }[] }
}

export const View = ({ title, data }: ViewProps) => (
	<Section id={AnchorsOfFormsWrappers.partner} fullWidth className={styles.fluidWrapper}>
		<Section className={styles.wrapper}>
			<div className={styles.summary}>
				<h2 className={styles.title}>{title}</h2>
				<div className={styles.summaryContent}>
					{Array.isArray(data.summary) &&
						data.summary.map(({ icon, text }, i) => (
							<div key={i} className={styles.summaryItem}>
								<Image name={icon} className={styles.summaryItemIcon} />
								{text}
							</div>
						))}
				</div>
			</div>
			<div className={styles.formWrapper}>
				<EstateAgentsForm
					placeholders={['Ваше имя', 'Номер телефона', 'Электронная почта']}
					btnText='Отправить'
				/>
			</div>
		</Section>
	</Section>
)
